import axios from 'axios';

// Global session guard: when the backend session expires (30-min sliding
// window), any authenticated API call returns 401. This clears the stale
// localStorage auth flags and redirects to /login with an "expired" notice.

let handling = false;

// Endpoints where a 401 is a normal outcome, not an expired session
const AUTH_EXEMPT = /\/api\/auth\/(login|register|session|logout|facebook)/;

const shouldLogout = (url, status) =>
  status === 401 &&
  String(url || '').includes('/api/') &&
  !AUTH_EXEMPT.test(String(url || '')) &&
  localStorage.getItem('isLoggedIn') === 'true';

export function forceLogout() {
  if (handling) return;
  handling = true;
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('user');
  window.dispatchEvent(new Event('auth-changed'));
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login?expired=1';
  } else {
    handling = false;
  }
}

export function installSessionGuard() {
  // Patch fetch (most of the app uses fetch)
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (shouldLogout(url, res.status)) forceLogout();
    } catch (_e) { /* never break the original call */ }
    return res;
  };

  // Axios interceptor (some tabs use axios)
  axios.interceptors.response.use(
    (r) => r,
    (error) => {
      if (shouldLogout(error?.config?.url, error?.response?.status)) forceLogout();
      return Promise.reject(error);
    }
  );

  // When the user returns to an idle tab, re-check the session immediately
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && localStorage.getItem('isLoggedIn') === 'true') {
      window.fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, { credentials: 'include' }).catch(() => {});
    }
  });
}
